import { Box, styled } from '@mui/material';
import { isAssetIgnition } from 'views/FleetOverview/helpers/asset.helpers';
import type { Asset } from 'types/asset.types';

interface IgnitionStatusIndicatorProps {
  latestTagData: any;
  asset: Asset;
  size?: number;
  marginRight?: string;
  showTooltip?: boolean;
  tooltipTitle?: string;
}

export const StatusDot = styled('span')<{ isActive: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) => (props.isActive ? '#199161' : '#fc0000')};
  margin-right: 5px;
  display: inline-block;
`;

// indicator styling for bumper numbers onselector dropdowns are in the Selector component

const IgnitionStatusIndicator = ({
  latestTagData,
  asset,
  size = 10,
  marginRight = '5px',
  showTooltip = false,
  tooltipTitle,
}: IgnitionStatusIndicatorProps) => {
  const isIgnitionActive = isAssetIgnition(latestTagData, asset);

  const defaultTooltipTitle = isIgnitionActive
    ? 'Vehicle is ON'
    : 'Vehicle is OFF';

  return (
    <Box
      sx={{
        display: 'inline-block',
        position: 'relative',
      }}
      title={showTooltip ? tooltipTitle ?? defaultTooltipTitle : undefined}
    >
      <StatusDot
        isActive={isIgnitionActive}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          marginRight,
        }}
      />
    </Box>
  );
};

export default IgnitionStatusIndicator;
